import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import Cookies from 'js-cookie';
import React, { createContext, useEffect, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.css';
import PrivateRoute from './components/common/PrivateRoute';
import Balance from './components/domain/balance/Balance';
import Bank from './components/domain/bank/Bank';
import BankAccountNumber from './components/domain/bankaccountnumber/BankAccountNumber';
import Category from './components/domain/bill/category/Category';
import Customer from './components/domain/bill/customer/Customer';
import IncomingBill from './components/domain/bill/incomingbill/IncomingBill';
import OutgoingBill from './components/domain/bill/outgoingbill/OutgoingBill';
import Project from './components/domain/bill/project/Project';
import Cash from './components/domain/cash/Cash';
import Owing from './components/domain/owing/Owing';
import Employee from './components/domain/salary/employee/Employee';
import OccasionalSalary from './components/domain/salary/salary/occasionalsalary/OccasionalSalary';
import Restrain from './components/domain/salary/restrain/restrain/Restrain';
import RestrainPartner from './components/domain/salary/restrain/restrainpartner/RestrainPartner';
import Salary from './components/domain/salary/salary/salary/Salary';
import AvailableDividend from './components/domain/salary/dividend/availabledividend/AvailableDividend';
import Dividend from './components/domain/salary/dividend/dividend/Dividend';
import Tax from './components/domain/tax/tax/Tax';
import TaxType from './components/domain/tax/taxtype/TaxType';
import Link from './components/domain/link/Link';
import Home from './components/navigation/Home';
import Login from './components/navigation/Login';
// import Logout from './components/navigation/Logout';
import Nav from './components/navigation/Nav';
import './style/styles.css';
import Vat from './components/domain/tax/vat/Vat';
import Close from './components/domain/close/Close';
import AvailableVacation from './components/domain/salary/vacation/availablevacation/AvailableVacation';
import Vacation from './components/domain/salary/vacation/vacation/Vacation';
import VacationCalendar from './components/domain/salary/vacation/vacation/VacationCalendar';
import OccasionalSalaryCalendar from './components/domain/salary/salary/occasionalsalary/OccasionalSalaryCalendar';
import WorkingHour from './components/domain/salary/employee/WorkingHour';
import Car from './components/domain/car/car/Car';
import CarDayPage from './components/domain/car/carday/CarDayPage';
import ProjectDetail from './components/domain/bill/project/detail/ProjectDetail';

export const GlobalCss = withStyles({
  // @global is handled by jss-plugin-global.
  '@global': {
    // You should target [class*="MuiButton-root"] instead if you nest themes.
    '.MuiButton-root': {
      textTransform: 'none'
    },
    '.MuiTimelineDot-root': {

    },
    '.MuiDialog-paperWidthSm': {
      'max-width': '650px'
    },
    '.MuiSvgIcon-colorPrimary': {
      color: '#4aa4d8'
    }
  },
})(() => null);

export const TableContext = createContext();

const App = () => {
  const [loggedIn, setLoggedIn] = useState(!!Cookies.get('__user'));
  const [instance, setInstance] = useState(null);

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      response => response,
      error => {
        const status = error && error.response && error.response.status;
        if (status === 401 || status === 403) {
          Cookies.remove('__user');
          Cookies.remove('__expires');
          setLoggedIn(false);
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptorId);
  }, []);

  useEffect(() => {
    if (!loggedIn) return;
    const expiresAt = Number(Cookies.get('__expires'));
    if (!expiresAt) return;
    const msUntilExpiry = expiresAt - Date.now();
    if (msUntilExpiry <= 0) {
      Cookies.remove('__user');
      Cookies.remove('__expires');
      setLoggedIn(false);
      return;
    }
    const timerId = setTimeout(() => {
      Cookies.remove('__user');
      Cookies.remove('__expires');
      setLoggedIn(false);
    }, msUntilExpiry);
    return () => clearTimeout(timerId);
  }, [loggedIn]);

  if (!loggedIn) {
    return <Login setLoggedIn={setLoggedIn} />
  }

  return (
    <BrowserRouter>
      <GlobalCss />
      <Switch>
        <>
          <Route path="/login" component={Login} setLoggedIn={setLoggedIn} />
          {/* <PrivateRoute path="/logout" component={Logout} /> */}
          <TableContext.Provider value={{ instance, setInstance }}>
            {/* <AHeader /> */}
            {/* <Header setLoggedIn={setLoggedIn} /> */}
            <Nav />
            <Switch>
              <PrivateRoute component={Home} path="/" exact />
              <PrivateRoute component={IncomingBill} path="/incomingbill" exact />
              <PrivateRoute component={OutgoingBill} path="/outgoingbill" exact />
              <PrivateRoute component={Project} path="/project" exact />
              <PrivateRoute component={ProjectDetail} path="/projectdetail/:id" exact />
              <PrivateRoute component={Balance} path="/balance" exact />
              <PrivateRoute component={Bank} path="/bank" exact />
              <PrivateRoute component={Category} path="/category" exact />
              <PrivateRoute component={Customer} path="/customer" exact />
              <PrivateRoute component={BankAccountNumber} path="/bankaccount" exact />
              <PrivateRoute component={Cash} path="/cash" exact />
              <PrivateRoute component={Employee} path="/employee" exact />
              <PrivateRoute component={Salary} path="/salary" exact />
              <PrivateRoute component={Restrain} path="/restrain" exact />
              <PrivateRoute component={Tax} path="/tax" exact />
              <PrivateRoute component={TaxType} path="/taxtype" exact />
              <PrivateRoute component={RestrainPartner} path="/restrainpartner" exact />
              <PrivateRoute component={OccasionalSalary} path="/occasionalsalary" exact />
              <PrivateRoute component={Vacation} path="/vacation" exact />
              <PrivateRoute component={AvailableVacation} path="/availablevacation" exact />
              <PrivateRoute component={AvailableDividend} path="/availabledividend" exact />
              <PrivateRoute component={Dividend} path="/dividend" exact />
              <PrivateRoute component={Owing} path="/owing" exact />
              <PrivateRoute component={Link} path="/link" exact />
              <PrivateRoute component={Vat} path="/vat" exact />
              <PrivateRoute component={Close} path="/close" exact />
              <PrivateRoute component={VacationCalendar} path="/vacationcalendar" exact />
              <PrivateRoute component={OccasionalSalaryCalendar} path="/occasionalsalarycalendar" exact />
              <PrivateRoute component={WorkingHour} path="/workinghours" exact />
              <PrivateRoute component={Car} path="/car" exact />
              <PrivateRoute component={CarDayPage} path="/carday" exact />
            </Switch>
          </TableContext.Provider>
        </>
      </Switch>
    </BrowserRouter>
  );

}
export default App;
